export default {"src":"/_next/static/media/verify-email.35f927ce.svg","height":373,"width":500};